module.exports = "<div class=\"footer\">\n  <a href=\"#\">Sign Out {{userDisplayName}}\n    <i class=\"fas fa-sign-out-alt\"></i>\n  </a>\n</div>"